export default {
  root: {
    padding: '2rem',
  }
};
